var ConfirmDialog = /** @class */ (function () {
    function ConfirmDialog() {
    }
    ConfirmDialog.prototype.activate = function (dataModel) {
        this.model = dataModel;
    };
    return ConfirmDialog;
}());
export { ConfirmDialog };
var GenericConfirmationDialogModel = /** @class */ (function () {
    function GenericConfirmationDialogModel() {
    }
    return GenericConfirmationDialogModel;
}());
export { GenericConfirmationDialogModel };
